import { YellowHorizontal } from '@/vm/Shared/YellowHorizontal.styles';
import type { VendingMachineLocation } from '~/contracts/vm';
import { FaqWrapper, FaqTitle } from './FrequentlyAskedQuestions.styles';
import injectFaqData from './injectFaqData';
import QuestionAndResponse from './QuestionAndResponse';

type OwnProps = {
  vendingMachineLocations: VendingMachineLocation[];
};

export default function FrequentlyAskedQuestions({
  vendingMachineLocations
}: OwnProps) {
  return (
    <FaqWrapper>
      <YellowHorizontal />
      <FaqTitle>FAQS</FaqTitle>
      {injectFaqData(vendingMachineLocations).map(faq => {
        const { question = '', answer = '', items = [] } = faq;

        return (
          <QuestionAndResponse
            key={question}
            question={question}
            answer={answer}
            items={items}
          />
        );
      })}
    </FaqWrapper>
  );
}
